import { ThemePreset } from "../types/theme";
import { defaultPresets } from "./theme-presets";

export const getPresetThemeStyles = (presetName: string) => {
  const preset = defaultPresets[presetName];
  if (!preset) {
    // Return default theme if preset not found
    // Try "elegant-luxury" first, fallback to "modern-minimal"
    return defaultPresets["elegant-luxury"]?.styles || defaultPresets["modern-minimal"].styles;
  }
  return preset.styles;
};

export const getAllPresetNames = (): string[] => {
  return ["default", ...Object.keys(defaultPresets)];
};

export const getPresetByName = (presetName: string): ThemePreset | undefined => {
  if (presetName === "default") {
    // Map "default" to "elegant-luxury" if it exists, otherwise "modern-minimal"
    return defaultPresets["elegant-luxury"] || defaultPresets["modern-minimal"];
  }
  return defaultPresets[presetName];
};

